import React from 'react';
import { Stack, Link } from '@fluentui/react';
import styles from './Citation.module.scss';

interface CitationProps {
  links?: string[];
}

const Citation: React.FC<CitationProps> = ({ links }) => {
  const getFileName = (link: string, index: number) =>
    decodeURIComponent(link.split('/').pop() || `File ${index + 1}`);

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }} className={styles.citationContainer}>
      {links?.map((link, index) => (
        <Link key={index} href={link} target="_blank" className={styles.citationLink}>
          {getFileName(link, index)}
        </Link>
      ))}
    </Stack>
  );
};

export default Citation;
